'use client';

import classNames from '@sindresorhus/class-names';
import interactionResponse from '@utils/await-interaction-response';
import {useState} from 'react';

import {useIsEllipsis} from '@web-catalog/hooks/useIsEllipsis';

import {logTmrEvent} from '@web-catalog/utils/analytics/logEvent';
import {LogTmrEvent} from '@web-catalog/utils/analytics/logEvents.entity';

import styles from './ReadMore.module.scss';
import {ColorVariant} from './types';

type Props = {
  /**
   * элемент к которому привязывается кнопка
   * если контент внутри обрезан, то кнопка покажется
   */
  targetElementId: string;
  /**
   * элемент на котором будет убираться класс truncateClassName,
   * если не указан, то дефолтится к targetElementId
   * (для координации не на уровне одного элемента, а группы)
   */
  truncateClassTargetElementId?: string;
  /** класс который отвечает за обрезку контента и который будет снят по нажатию на кнопку */
  truncateClassName: string;
  colorVariant: ColorVariant;
  buttonClickLogData?: LogTmrEvent;
};

export const ReadMore = ({
  targetElementId,
  truncateClassTargetElementId = targetElementId,
  truncateClassName,
  colorVariant,
  buttonClickLogData,
}: Props) => {
  const [buttonClicked, setButtonClicked] = useState(false);
  const isEllipsis = useIsEllipsis(targetElementId);

  const onButtonClick = async () => {
    await interactionResponse();
    const element = document.getElementById(truncateClassTargetElementId);
    if (element) {
      element?.classList.remove(truncateClassName);
    }
    setButtonClicked(true);
    if (buttonClickLogData) {
      logTmrEvent(buttonClickLogData);
    }
  };

  if (!isEllipsis || buttonClicked) {
    return null;
  }

  return (
    <button
      className={classNames(styles.root, styles[colorVariant])}
      onClick={onButtonClick}
      data-testid="read-more"
    >
      Ещё
    </button>
  );
};
